/// <amd-module name="typeahead/core/logging/DctkClientLogErrorTransport"/>

/// <reference path="../../../typings/typeahead/clientLogging.d.ts"/>
/// <reference path="../../../typings/typeahead/modulizr.d.ts" />

import {IClientLogging} from "dctk/clientLogging";
import {IErrorTransport} from "typeahead/core/logging/ErrorTransport";
import {ProblemOrigin} from "typeahead/core/logging/ProblemOrigin";
import {Severity} from "typeahead/core/logging/Severity";

interface IPlatformAnalyticsClientLogger {
    logMessage(messageToLog: string, level: string, additionalData: string[]);
    logError(errorToLog: string, error: Error, additionalData: string[]);
}

export class DctkClientLogErrorTransport implements IErrorTransport {
    private readonly UTA_LABEL = "UniversalTypeahead";
    private isDctkEnabled = false;
    private isPlatformAnalyticsEnabled = false;
    public log(e: Error, severity: Severity, origin: ProblemOrigin, additional: any = {}): void {
        try {
            if (typeof additional !== "object") {
                const tmp = additional;
                additional = {};
                additional.additional_info = tmp;
            }
            if (severity in [0, 1, 2]) {
                additional.severity = Severity[severity];
            }
            if (origin) {
                additional.problemOrigin = ProblemOrigin[origin];
            }
            if (Severity.MustFix !== severity && e) {
                additional.message = e.message;
                additional.name = e.name;
                additional.stack = e.stack;
            }
            require(["dctk/clientLogging", "dctk/dctk"], (cl) => {
                if (!this.isPlatformAnalyticsEnabled) {
                    this.isDctkEnabled = true;
                    this.doDctkClientLogging(e, severity, additional, cl);
                }
            });
            require(["PlatformAnalytics"], (platformAnalytics) => {
                if (!this.isDctkEnabled) {
                    this.isPlatformAnalyticsEnabled = true;
                    const pa: any = platformAnalytics.getInstance() || platformAnalytics.newInstance();
                    this.doPlatformAnalyticsClientLogging(e, severity, additional, pa.getClientLog());
                }
            });
        } catch (e) {
            // Ignore
        }
    }
    private doDctkClientLogging(e: Error, severity: Severity, additional: any, cl: IClientLogging): void {
        if (Severity.MustFix === severity) {
            cl.logError(this.UTA_LABEL, e, additional);
        } else {
            cl.logMessage(this.UTA_LABEL, additional);
        }
    }
    private doPlatformAnalyticsClientLogging(e: Error, severity: Severity, additional: any,
                                             cl: IPlatformAnalyticsClientLogger): void {
        if (additional && "guid" in additional) {
            delete additional.guid; // guid is set by Platform Analytics API and it throws an error if explicitly set
        }
        const data: any = Object.keys(additional).map((key) => key + "=" + additional[key]);
        if (Severity.MustFix === severity) {
            cl.logError(this.UTA_LABEL, e, data);
        } else {
            cl.logMessage(this.UTA_LABEL, undefined, data);
        }
    }
}
